export const FETCH_APIKEYS = "FETCH_APIKEYS";
export const FETCH_APIKEY = "FETCH_APIKEY";
export const CREATE_APIKEY = "CREATE_APIKEY";
export const UPDATE_APIKEY = "UPDATE_APIKEY";
export const DEACTIVATE_APIKEY = "DEACTIVATE_APIKEY";
export const DELETE_APIKEY = "DELETE_APIKEY";
export const APIKEY_ERROR = "APIKEY_ERROR";
export const CLEAR_APIKEY_ERROR = "CLEAR_APIKEY_ERROR";